import { render, staticRenderFns } from "./PerformanceTrafficLight.vue?vue&type=template&id=53ead1d8"
import script from "./PerformanceTrafficLight.vue?vue&type=script&lang=ts"
export * from "./PerformanceTrafficLight.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports